import { ResultType } from "graphql/types"

export const getResultTypeName = (result: ResultType) => {
  switch (result) {
    case ResultType.PASSED:
      return "passed"
    case ResultType.FAILED:
      return "failed"
    case ResultType.NOT_EVALUATED:
      return "not evaluated"
    default:
      return "not evaluated"
  }
}

export const getResultTypeNameForReport = (result: string) => {
  switch (result) {
    case ResultType.PASSED:
      return "passed"
    case ResultType.FAILED:
      return "failed"
    case ResultType.NOT_EVALUATED:
      return "./."
    default:
      return "./."
  }
}
